import React from 'react'

import { Dashboard } from '@components/common/Dashboard/Dashboard'
import { PageLayout } from '@components/common/PageLayout'
import { useDashboardPermissions } from '@components/utils/DashboardPermissions/useDashboardPermissions'
import {
  Button,
  HeadContent,
  List,
  Pagination,
  Table,
  ToolbarButton,
  useMediaQueryContext,
} from '@fourthwall/components'
import { PlusIcon } from '@fourthwall/icons'
import { routing } from '@utils/routing'

import { useSeriesContext } from './hooks/useSeriesContext'
import { SeriesProvider } from './providers/SeriesProvider'

const SeriesComponent = () => {
  const { hasPermission } = useDashboardPermissions()

  const media = useMediaQueryContext()
  const { table, list, pageCount, currentPage, setCurrentPage } = useSeriesContext()

  const getToolbarContent = () => {
    if (!hasPermission('memberships.video.create')) return null

    if (media.tablet) {
      return (
        <Button
          size="small"
          label="Add new video series"
          appearance="primary"
          to={routing.memberships.series.create}
        />
      )
    }

    return (
      <ToolbarButton
        label="Add new video series"
        icon={PlusIcon}
        to={routing.memberships.series.create}
      />
    )
  }

  return (
    <PageLayout size="large">
      <Dashboard.Section
        name="Video series"
        bottomMargin="medium"
        toolbarContent={getToolbarContent()}
      >
        <HeadContent title="Video series" />
        <Dashboard.Section.Item>
          {media.tablet ? <Table {...table} /> : <List {...list} />}
        </Dashboard.Section.Item>
        {pageCount !== 1 && (
          <Dashboard.Section.Item>
            <Pagination pageCount={pageCount} currentPage={currentPage} onChange={setCurrentPage} />
          </Dashboard.Section.Item>
        )}
      </Dashboard.Section>
    </PageLayout>
  )
}

export const Series = () => (
  <SeriesProvider>
    <SeriesComponent />
  </SeriesProvider>
)
